import { t as uiText } from '../../i18n';
import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import DynamicEmbedCodeBlock from './DynamicEmbedCodeBlock';

interface DynamicEmbedCodeModalProps {
  token: string;
  publishId: string;
  allowedOrigins?: string[];
  onClose: () => void;
}

const DynamicEmbedCodeModal: React.FC<DynamicEmbedCodeModalProps> = ({ token, publishId, allowedOrigins, onClose }) => {
  useEffect(() => {
    const onKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', onKeyDown);
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', onKeyDown);
      document.body.style.overflow = prevOverflow;
    };
  }, [onClose]);

  return createPortal(
    <div className="dynamic-embed-modal" onClick={onClose}>
      <div
        className="dynamic-embed-modal__dialog"
        role="dialog"
        aria-modal="true"
        aria-label={uiText("Public button script")}
        onClick={(event) => event.stopPropagation()}
      >
        <button type="button" className="dynamic-embed-modal__close" onClick={onClose} aria-label={uiText("Close")}>
          ×
        </button>
        <DynamicEmbedCodeBlock token={token} publishId={publishId} allowedOrigins={allowedOrigins} />
      </div>
    </div>,
    document.body,
  );
};

export default DynamicEmbedCodeModal;
